require('./_wks-define')('observable');



//////////////////
// WEBPACK FOOTER
// ./~/.pnpm/core-js@2.6.12/~/core-js/library/modules/es7.symbol.observable.js
// module id = 152
// module chunks = 1 2 3